import Vue from 'vue'
import app from '@/main'

const listProductRecommendationModule = {
  namespaced: true,
  state: {
    services: {},
    loadingServices: false
  },

  mutations: {
    setServices: (state, services) => (state.services = services),
    setLoadingServices: (state, loading) => (state.loadingServices = loading)
  },

  getters: {
    getAllServicesWithRuleCount: (state) => {
      return state.services.services_details.map((el) => {
        el.rules_count = 0
        Object.keys(state.services.business_rules_config).forEach((key) => {
          if (el.name === key) {
            Object.values(state.services.business_rules_config[key]).forEach((element) => {
              if (Array.isArray(element)) {
                el.rules_count += element.length
              }
            })
          }
        })
        return el
      })
    }
  },

  actions: {
    GET_ALL_SERVICES: async ({ commit, rootGetters }) => {
      commit('setLoadingServices', true)
      try {
        const response = await Vue.http.get(`${rootGetters.getBackendUrl}/recommendations/list`, {
          headers: rootGetters.getAllResponseHeaders
        })

        if (response.body.services_details.status === 'error') {
          commit('setServices', { business_rules: {}, services_details: [] })
          return commit('setLoadingServices', false)
        }

        if (response.ok) {
          commit('setServices', response.body)
          commit('setLoadingServices', false)
        }
      } catch (e) {
        app.$raven.captureException(e)
      }
    }
  }
}

export default listProductRecommendationModule



// WEBPACK FOOTER //
// ./src/store/modules/recommendations/modules/list_product_recommendation.js